const ONE_SECOND = 1000
export const POLLING_INTERVAL = 5 * ONE_SECOND
export const POLLING_RETRIES = 999
